import { nvl, nvlDateTypeReturnToStringOnlyDate } from 'utils/nvl';

export function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    index: pageIndex * pageSize + index + 1,
    userIdx: d.userIdx,
    userId: d.userId,
    userPw: d.userPw,
    userNm: d.userNm,
    userTel: d.tel,
    smsFlag: d.smsFlag,
    authNm: d.auth === null ? '' : d.auth.authNm,
    authIdx: d.auth === null ? 0 : d.auth.authIdx,
    rgstId: nvl(d.rgstId, ''),
    rgstDt: nvlDateTypeReturnToStringOnlyDate(d.rgstDt, ''),
  };
}
